import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import Tooltip from '@material-ui/core/Tooltip'
import _ from 'lodash'
import { Presupuestador as BFFPresupuestador } from '../../common/BFF/BFF_presupuestador'
import { Catalogs as BFFCatalogs } from '../../common/BFF/BFF_catalogs'
import {ErrorAction} from '../common/redux/toasts'
import { removePresupuestoUltimoEditado } from '../../common/BFF/BFF_presupuestador/ultimoPresupuestoEditado'

const EMPTY_GROUP_IDENTIFIER = 'null'

const menuCerrarSesion = {
  name: 'Cerrar sesión',
  slug: 'logout',
  icon: 'exit_to_app',
  content: [],
}

const menuInicio = {
  name: 'Inicio',
  slug: 'inicio',
  icon: 'house',
  content: [],
}

class SidebarContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuItemsDictionary: {},
    }
  }

  componentDidMount() {
    this.generateMenuItemsDictionary()
  }

  generateMenuItemsDictionary() {
    const availablesMenus = this.props.user.system
    const menuItemsDictionary = _.groupBy(availablesMenus, 'group')
    this.setState({ menuItemsDictionary })
  }

  renderNavLink(item, index) {
    if (item.content.length === 0) {
      if(item.name==="Pagos" && this.props.hasPayment || item.name!=="Pagos"){
        return (
          <Tooltip
          title={item.name}
          placement="right"
          disableHoverListener={!this.props.sidebarCollapsed}
          disableFocusListener={!this.props.sidebarCollapsed}
          disableTouchListener
        >
          <NavLink
            key={index}
            to={`/${item.slug}`}
            className={`sidebar-link`}
            activeClassName="active"
            data-menu-item-name={item.name}
            data-menu-group={item.group}
            onClick={(e) => this.clickOnMenu(e, item.slug)}
          >
            <i className="material-icons-outlined sidebar-icons">{item.icon}</i>
            <span className="nav-link-name">{item.name}</span>
          </NavLink>
        </Tooltip>
        )
      }
    } else {
      if (this.props.sidebarCollapsed) {
        return (
          <Tooltip
            title={item.name}
            placement="right"
          >
            <div
              className={`sidebar-link ${item.active ? 'active' : 'inactive'} ${item.expand ? 'expand' : 'collapse'
                }`}
              data-menu-item-name={item.name}
              data-menu-group={item.group}
              onClick={this.toggleExpand}
            >
              <i className="material-icons-outlined sidebar-icons">{item.icon}</i>
              <span className="nav-link-name" >{item.name}</span>
              <i className="material-icons expand-icon">
                {item.expand ? 'expand_less' : 'expand_more'}
              </i>
            </div>
          </Tooltip>
        )
      } else {
        return (
          <div
            className={`sidebar-link ${item.active ? 'active' : 'inactive'} ${item.expand ? 'expand' : 'collapse'}`}
            data-menu-item-name={item.name}
            data-menu-group={item.group}
            onClick={this.toggleExpand}
          >
            <i className="material-icons-outlined sidebar-icons">{item.icon}</i>
            <span className="nav-link-name">{item.name}</span>
            <i className="material-icons expand-icon">
              {item.expand ? 'expand_less' : 'expand_more'}
            </i>
          </div>
        )
      }
    }
  }

  toggleExpand = (event) => {
    const menuItemsDictionary = this.state.menuItemsDictionary
    const menuItemName = event.currentTarget.dataset.menuItemName
    const menuGroup = event.currentTarget.dataset.menuGroup
    menuItemsDictionary[menuGroup]?.forEach(menu => {
      if (menu.name === menuItemName) {
        menu.expand = !menu.expand
      }
    });
    this.setState({ menuItemsDictionary })
    this.props.expandSidebar()
    setTimeout(function(){document.getElementById(menuItemName).scrollIntoView({behavior: "smooth"})
    }, 0);
  }

  checkPresupuestadorLocation = (e, slug) => {
    if(
      this.props.location.pathname.includes('presupuestador/crear') ||
      this.props.location.pathname.includes('presupuestador/editar') ||
      this.props.location.pathname.includes('presupuestador/ultimo-editado')
    ) {
      e.preventDefault();
      this.props.onPresupuestadorLocationChange(slug);
    }
  };

  checkFastStockLoadingLocation = (e, slug) => {
    if(
      this.props.location.pathname.includes('stock/gestion-de-usados/carga-rapida-usados')
    ) {
      e.preventDefault();
      this.props.onFastStockLoadingLocationChange(slug);
    }
  }

  checkDashboardLocation = (e, slug) => {
    if(this.props.location.pathname.includes('dashboard')) {
      e.preventDefault();
      this.props.onDashboardLocationChange(slug);
    }
  }

  checkPrecioJustoLocation = (e, slug) => {
    if (this.props.location.pathname.includes('precio-justo/search')) {
      e.preventDefault();
      this.props.onPrecioJustoLocationChange(slug);
    }
  }

  checkGestorDeLeads = (slug) => {
    if (this.props.location.pathname.includes('gestor-leads')) {
      this.props.handleGestorLeadsdLocationChange(slug);
    }
  }

  clickOnSubMenu = (event, slug) => {
    this.isSameUrl(event, slug)
    
    const submenuItemName = event.currentTarget.dataset.submenuItemName
    const submenuGroup = event.currentTarget.dataset.submenuGroup
    this.activeMenuItem(submenuItemName, submenuGroup)
    this.checkPresupuestadorLocation(event, slug);
    this.checkFastStockLoadingLocation(event, slug);
    this.checkDashboardLocation(event, slug);
    this.checkPrecioJustoLocation(event, slug);
  }

  activeMenuItem = (itemName, group = EMPTY_GROUP_IDENTIFIER) => {
    const menuItemsDictionary = this.state.menuItemsDictionary

    menuItemsDictionary[group]?.forEach(menu => {
      if (menu.name === itemName) {
        menu.active = true
      } else {
        menu.active = false
      }
    })

    this.setState({ menuItemsDictionary })
    if (this.props.isMobile) {
      setTimeout(this.props.closeMenu, 200)
    }
  }

  isSameUrl = (event, slug) => {
    if(this.props.location.pathname === `/${slug}`) event.preventDefault();
  }

  clickOnMenu = (event, slug) => {
    this.isSameUrl(event, slug)
    
    const menuItemName = event.currentTarget.dataset.menuItemName
    const menuGroup = event.currentTarget.dataset.menuGroup

    this.activeMenuItem(menuItemName, menuGroup)
    this.checkPresupuestadorLocation(event, slug);
    this.checkFastStockLoadingLocation(event, slug);
    this.checkDashboardLocation(event, slug);
    this.checkPrecioJustoLocation(event, slug);
    this.checkGestorDeLeads(slug);
  }

  validateProductCatalog = async (content) =>{
    const ultimoPresupuesto = BFFPresupuestador.getPresupuestoUltimoEditado(
      this.props.user.id
    )
    const catalog_id = ultimoPresupuesto.catalog_id || ultimoPresupuesto.nuevo.id;
    const car_lot_id = ultimoPresupuesto.car_lot_id || ultimoPresupuesto.nuevo.car_lot_id;
    const catalogo = await BFFCatalogs.getCatalogId(catalog_id, car_lot_id)
    if(catalogo.published){
      this.props.history.push(`/${content.slug}`)
    }else{
      ErrorAction({title: "El producto pre-seleccionado anteriormente ya no esta disponible. Realizá un nuevo presupuesto"})
      this.props.removeMenuPresupuestoUltimoEditado()
      removePresupuestoUltimoEditado(this.props.user.id)
    }
  }

  renderSubMenu(content, item, index, subIndex) {
    return (
      <Tooltip
        title={content.name}
        placement="right"
        disableHoverListener={!this.props.sidebarCollapsed}
        disableFocusListener={!this.props.sidebarCollapsed}
        disableTouchListener
        key={index + '_' + subIndex}
      >
        <div>
        {content.slug==='presupuestador/ultimo-editado' ? (
          <div className={`active-ultimo-editado sidebar-link-sub-item ${
            item.expand === true ? '' : 'item-hide'
          }`}>
              <button className="p-0" onClick={()=>this.validateProductCatalog(content)}><li>{content.name}</li></button>
          </div>
          ): (
              <NavLink
                to={`/${content.slug}`}
                className={`sidebar-link-sub-item ${
                  item.expand === true ? '' : 'item-hide'
                }`}
                activeClassName="active"
                data-submenu-item-name={item.name}
                data-submenu-group={item.group}
                onClick={(e) => this.clickOnSubMenu(e, content.slug)}
                exact
              >
                <span className="nav-sub-initials">{content.initials}</span>
                <li />
                <span className="nav-sub-link-name">{content.name}</span>
              </NavLink>
            )
        }
        </div>

      </Tooltip>
    )
  }

 renderMenuNavLink = () => {
  return Object.entries(this.state.menuItemsDictionary).map(
    (entry) => {
      const group = entry[0]
      const items = entry[1]

      return (
        <React.Fragment key={group}>
          <div className="border-on-top"/>
          {group !== EMPTY_GROUP_IDENTIFIER &&
            !Boolean(this.props.sidebarCollapsed) && (
              <div className="group-name">{group}</div>
            )}
          {items.map((item, index) => this.renderMenuItem(item, index))}
        </React.Fragment>
      )
    }
  )
 }

  renderMenuItem = (item, index) => (
    <div className="menu-item" key={index + item.slug} id={item.name}>
      {this.renderNavLink(item, index)}
      {!Boolean(this.props.sidebarCollapsed) && item.content.map((content, subIndex) =>
        this.renderSubMenu(content, item, index, subIndex)
      )}
    </div>
  )

  render() {
    return (
      <div className={'sidebar-content collapsed-' + (!!this.props.sidebarCollapsed && !this.props.isMobile)}>
        <div className="menu-main-container">
          <div className="menu-item menu-inicio">
            {this.renderNavLink(menuInicio)}
          </div>
          {this.renderMenuNavLink()}
          <div className="menu-item menu-cerrar-session border-on-top">
            {this.renderNavLink(menuCerrarSesion)}
          </div>
        </div>
      </div>
    )
  }
}

SidebarContent.propTypes = {
  style: PropTypes.object,
}

export default SidebarContent
